import { useContext } from 'react';
import { faDash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableHeaderContext } from 'components/table/TableContext';
import { ascIconFactory, descIconFactory } from 'components/table/util';
import { twJoin } from 'tailwind-merge';

const TableHeaderSort = () => {
    const { header } = useContext(TableHeaderContext);
    const column = header.column;
    const sortType = column.columnDef.meta?.sortType ?? 'alpha';
    const ascIcon = ascIconFactory(sortType);
    const descIcon = descIconFactory(sortType);
    const sortDir = column.getIsSorted();
    const isSorted = typeof sortDir === 'string';
    const sortIcon = sortDir === 'desc' ? descIcon : ascIcon;

    return (
        <FontAwesomeIcon className={twJoin('text-gray-400')} icon={isSorted ? sortIcon : faDash} />
    );
};

export { TableHeaderSort };
